import script from "./LoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=4b73a2da&lang=scss"

const __exports__ = script;

export default __exports__